import React, { useEffect, useRef } from "react";
import constructionImg from "../assets/css/construction.jpg";
import propertyManagementImg from "../assets/css/propertymanagement.jpg";
import propertySourcingImg from "../assets/css/propertysourcing.jpg";

function UpdatedSlider() {
    const sliderRef = useRef(null);
    useEffect(() => {
        if (window.Swiper && sliderRef.current && !sliderRef.current.swiper) {
            const options = {
                slidesPerView: 1,
                loop: true,
                effect: "fade",
                fadeEffect: { crossFade: true },
                speed: 600,
                grabCursor: true,
                keyboard: { enabled: true },
                pagination: {
                    el: "#main-slider-pagination",
                    type: "bullets",
                    clickable: true,
                },
                navigation: {
                    nextEl: "#main-slider__swiper-button-next",
                    prevEl: "#main-slider__swiper-button-prev",
                },
                autoplay: { delay: 5000, disableOnInteraction: false },
            };
            new window.Swiper(sliderRef.current, options);
        }
    }, []);
    const slides = [
        {
            image: propertyManagementImg,
            title:
                "Property Management – Full-service oversight for residential & mixed-use assets",
        },
        {
            image: constructionImg,
            title:
                "Construction & Renovation – Ground-up builds and value-add renovations",
        },
        {
            image: propertySourcingImg,
            title:
                "Property Sourcing – Identifying undervalued and off-market opportunities",
        },
    ];

    return (
        <section className="main-slider main-slider-one" id="home">
            <div
                className="swiper-container thm-swiper__slider"
                ref={sliderRef}
                data-swiper-options='{"slidesPerView": 1, "loop": true, "effect": "fade", "fadeEffect": {"crossFade": true}, "speed": 600, "grabCursor": true, "keyboard": {"enabled": true}, "pagination": {"el": "#main-slider-pagination","type": "bullets","clickable": true}, "navigation": {"nextEl": "#main-slider__swiper-button-next","prevEl": "#main-slider__swiper-button-prev"}, "autoplay": {"delay": 5000, "disableOnInteraction": false}}'
            >
                <div className="swiper-wrapper">
                    {slides.map((slide, idx) => (
                        <div className="swiper-slide" key={idx}>
                            <div
                                className="image-layer"
                                style={{ backgroundImage: `url(${slide.image})` }}
                            ></div>
                            <div className="container slider-container">
                                <div className="main-slider__content">
                                    <h2 className="main-slider__content-title">{slide.title}</h2>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                <div className="swiper-pagination" id="main-slider-pagination"></div>
                <div className="main-slider__nav">
                    <div className="swiper-button-prev" id="main-slider__swiper-button-prev">
                        <span className="icon-left"></span>
                    </div>
                    <div className="swiper-button-next" id="main-slider__swiper-button-next">
                        <span className="icon-right"></span>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default UpdatedSlider;
